import TableAction from './table-action';

export default TableAction;
